import { useState, useEffect } from 'react'
import { ShieldOff, Save, Loader2 } from 'lucide-react'
import { useOrganizador } from '../../contexts/OrganizadorContext'
import { useAuthStore } from '../../stores/authStore'
import { toast } from 'react-hot-toast'
import isencaoDefesaConfigService from '../../services/isencaoDefesaConfigService'

export default function IsencaoDefesa() {
  const { organizadorAtivo } = useOrganizador()
  const { user } = useAuthStore()
  const isAdmin = user?.permission_level === 'admin' || user?.permission_level === 'super_admin'

  const [ativo, setAtivo] = useState(false)
  const [percentualLimite, setPercentualLimite] = useState('25.00')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!organizadorAtivo?.id) return
    setLoading(true)
    isencaoDefesaConfigService.getConfig(organizadorAtivo.id)
      .then(cfg => {
        setAtivo(!!cfg.ativo)
        setPercentualLimite(String(cfg.percentual_limite ?? '25.00'))
      })
      .catch(err => toast.error(err.response?.data?.detail || 'Erro ao carregar configuração'))
      .finally(() => setLoading(false))
  }, [organizadorAtivo?.id])

  const handleSalvar = async () => {
    const pct = parseFloat(String(percentualLimite).replace(',', '.'))
    if (isNaN(pct) || pct < 0 || pct > 100) {
      toast.error('Informe um percentual válido entre 0 e 100')
      return
    }
    setSaving(true)
    try {
      await isencaoDefesaConfigService.saveConfig(organizadorAtivo.id, {
        ativo,
        percentual_limite: pct,
      })
      toast.success('Configuração salva')
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao salvar')
    } finally {
      setSaving(false)
    }
  }

  if (!organizadorAtivo) return null

  return (
    <div className="max-w-2xl space-y-4">
      <div className="flex items-center gap-2">
        <ShieldOff className="w-5 h-5 text-red-600" />
        <h1 className="text-lg font-semibold text-gray-800">Isenções Defesa</h1>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 space-y-4">
        <p className="text-sm text-gray-600">
          Quando ligado, o botão "Isentar Defesa" (no Mapa do Vendedor e na Fatura do Vendedor)
          só aparece pra vendedores que defenderam — em valor — menos que o percentual abaixo
          do que ofereceram no leilão. A isenção continua sendo aplicada manualmente, com um
          clique de confirmação — essa configuração só controla quando o botão fica disponível.
        </p>

        {loading ? (
          <div className="flex items-center gap-2 text-sm text-gray-500 py-4">
            <Loader2 className="w-4 h-4 animate-spin" /> Carregando...
          </div>
        ) : (
          <>
            <label className="flex items-center gap-3 cursor-pointer">
              <input type="checkbox" checked={ativo} disabled={!isAdmin}
                onChange={e => setAtivo(e.target.checked)}
                className="w-4 h-4" />
              <span className="text-sm font-medium text-gray-800">
                Habilitar isenção por percentual defendido
              </span>
            </label>

            <div className="flex flex-col gap-1 max-w-xs">
              <label className="text-xs text-gray-500 font-medium">
                Percentual limite (%)
              </label>
              <input type="text" inputMode="decimal" value={percentualLimite} disabled={!isAdmin}
                onChange={e => setPercentualLimite(e.target.value)}
                className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-400" />
              <span className="text-xs text-gray-400">
                Vendedor com % defendido abaixo deste valor fica elegível.
              </span>
            </div>

            {!isAdmin && (
              <p className="text-xs text-amber-600">
                Apenas administradores podem alterar essa configuração.
              </p>
            )}

            {isAdmin && (
              <button onClick={handleSalvar} disabled={saving}
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 text-white rounded-lg text-sm font-medium transition-colors">
                <Save className="w-4 h-4" /> {saving ? 'Salvando...' : 'Salvar'}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  )
}
